// extracted by mini-css-extract-plugin
export default {"main":"index_main__48aO1","left":"index_left__f5jIe","title":"index_title__h-gGH","desc":"index_desc__xBCut"};